{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Naujas pranešimas",
  "chat.scrollToBottom": "Slinkite žemyn",
  "messagefeedback.thumbDown": "Blogas atsakas",
  "messagefeedback.thumbUp": "Geras atsakas",
  "promptfield.aiDisclaimer": "Atsakymai generuojami naudojant DI ir gali būti netikslūs. Patikrinkite prieš naudojant.",
  "promptfield.aiUserGuidlines": "DI naudotojo gairės",
  "promptfield.attachments": "Priedai",
  "promptfield.insertButton": "Pridėti",
  "promptfield.label": "Raginimas",
  "promptfield.placeholder": "Pasiruošę pradėti? Užduokite klausimą, pasidalykite idėja arba pridėkite užduotį.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Sustoti, sustok",
  "promptfield.submitButton": "Siųsti",
  "promptfield.uploading": "Įkėlimas",
  "responsestatus.loading": "Įkeliama",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Pradėkite įrašinėti",
  "voicebutton.stopListening": "Sustabdyti įrašymą",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
